import React, { useEffect } from "react";
import { FieldValues, useForm } from "react-hook-form";
import CustomInput from "../CustomInput";
import CustomRadio from "../customRadio";
import DatePicker from "react-datepicker";

import { useRef, useState } from "react";
import {
  car_key,
  baby_seat,
  mdi_car_insurance,
  steering_wheel,
  wind_shield_protection_icon,
} from "../../assets/images";
import { useMutation, useQuery } from "@tanstack/react-query";
import { trackEvent } from "../../services/events";
import ReactPixel from "react-facebook-pixel";
import { CustomerDetails, DocumentDetails } from "../../types";
import axiosInstance from "../../services/axios.instance";
import { API_URL } from "../../services/apiConfig";
import "./styles.css";
import "./datepicker-custom.css";
import CustomCheckBox from "../customCheckbox";
import { useLocation, useNavigate } from "react-router-dom";
import { Calendar3, Trash, Upload } from "react-bootstrap-icons";
import rules from "../../rules";

import { RentalSummarySecondPage } from "..";
import { setBookingValues } from "../../Redux/BookingData/bookingDataSlice";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Capacitor } from "@capacitor/core";

const NonInsuranceHolderSecondPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAndroid = Capacitor.getPlatform();

  const {
    control,
    handleSubmit,
    formState: { isValid },
    getValues,
    setValue,
    trigger,
  } = useForm({ mode: "onChange" });

  const [yearDropdownOpen, setYearDropdownOpen] = useState(false);
  const [monthDropdownOpen, setMonthDropdownOpen] = useState(false);

  const years = Array.from(
    { length: 20 },
    (_, i) => new Date().getFullYear() + 1 + i
  );
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const renderCustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }: any) => (
    <div className="datepicker-custom-header">
      <button
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        type="button"
        className="datepicker-nav-btn"
      >
        {"<"}
      </button>
      <div className="datepicker-dropdowns">
        {/* Custom Year Dropdown */}
        <div className="custom-select-wrapper year-wrapper">
          <div
            className="custom-select-selected"
            onClick={() => {
              setYearDropdownOpen(!yearDropdownOpen);
              setMonthDropdownOpen(false);
            }}
          >
            {date.getFullYear()}
            <span className={`arrow ${yearDropdownOpen ? "up" : "down"}`}></span>
          </div>
          {yearDropdownOpen && (
            <div className="custom-select-options scrollable-options">
              {years.map((year) => (
                <div
                  key={year}
                  className={`custom-select-option ${date.getFullYear() === year ? "selected" : ""}`}
                  onClick={() => {
                    changeYear(year);
                    setYearDropdownOpen(false);
                  }}
                >
                  {year}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Custom Month Dropdown */}
        <div className="custom-select-wrapper month-wrapper">
          <div
            className="custom-select-selected"
            onClick={() => {
              setMonthDropdownOpen(!monthDropdownOpen);
              setYearDropdownOpen(false);
            }}
          >
            {months[date.getMonth()]}
            <span className={`arrow ${monthDropdownOpen ? "up" : "down"}`}></span>
          </div>
          {monthDropdownOpen && (
            <div className="custom-select-options scrollable-options">
              {months.map((month, index) => (
                <div
                  key={month}
                  className={`custom-select-option ${date.getMonth() === index ? "selected" : ""}`}
                  onClick={() => {
                    changeMonth(index);
                    setMonthDropdownOpen(false);
                  }}
                >
                  {month}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <button
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        type="button"
        className="datepicker-nav-btn"
      >
        {">"}
      </button>

      {/* Backdrop to close dropdowns when clicking outside */}
      {(yearDropdownOpen || monthDropdownOpen) && (
        <div
          className="datepicker-dropdown-backdrop"
          onClick={() => {
            setYearDropdownOpen(false);
            setMonthDropdownOpen(false);
          }}
        />
      )}
    </div>
  );

  const isStripeFeeEnabled = String(process.env.REACT_APP_STRIPE_BOOLEAN) === "true";

  const [expiryDate, setExpiryDate] = useState<string | undefined>(undefined);
  const [expiryError, setExpiryError] = useState("");
  const [touristExpiryDate, setTouristExpiryDate] = useState<string | undefined>(undefined);
  const [touristExpiryError, setTouristExpiryError] = useState("");
  const [licenseFileError, setLicenseFileError] = useState("");
  const [emiratesIdFileError, setEmiratesIdFileError] = useState("");
  const [licenseFile2Error, setLicenseFile2Error] = useState("");
  const [visitVisaFileError, setVisitVisaFileError] = useState("");
  const [passportFileError, setPassportFileError] = useState("");
  const [customerDocTypeError, setCustomerDocTypeError] = useState("");
  const docsErrorSectionRef = useRef<HTMLDivElement | null>(null);

  const [isCarRentalAllowed, setIsCarRentalAllowed] = useState<boolean>(false);
  // const [selectedOption, setSelectedOption] = useState<string>("");
  const [selectedOption1, setSelectedOption1] = useState<string>("");
  const [isLicenseLoading, setIsLicenseLoading] = useState(false);

  const [babySeatSelected, setBabySeatSelected] = useState<boolean>(false);

  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
  const [isDriverButtonDisabled, setIsDriverButtonDisabled] =
    useState<boolean>(true);
  const [iswtpButtonDisabled, setIsWTPButtonDisabled] = useState<boolean>(true);

  const [additionalDriverSelected, setAdditionalDriverSelected] =
    useState<boolean>(false);

  const [wtpSelected, setWTPSelected] = useState<boolean>(false);
  const [scdwSelected, setSCDWSelected] = useState<boolean>(false);
  const [cdwSelected, setCDWSelected] = useState<boolean>(false);

  const [licenseUploadCount, setLicenseUploadCount] = useState(0);
  const [emiratesUploadCount, setEmiratesUploadCount] = useState(0);
  const [visaUploadCount, setVisaUploadCount] = useState(0);
  const [passportUploadCount, setPassportUploadCount] = useState(0);
  const [driverFeeConfig, setDriverFeeConfig] = useState<
    {
      id: number;
      delivery_type: string | null;
      amount: number;
      number_of_days: string | null;
      status: boolean | null;
      merchant_id: string;
      merchant_name: string | null;
      frequency: "DAILY" | "WEEKLY" | "MONTHLY";
      created_at: string | null;
      updated_at: string | null;
    }[]
  >([]);

  const { bookingValues } = useSelector((state: any) => state.bookingValues);
  // const handleRadioChange = (value: string) => {
  //   // setSelectedOption(value);
  //   dispatch(setBookingValues({ ...bookingValues, insuranceType: value }));
  // };
  const fetchDriverFeeConfig = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL.DRIVER_FEE_CONFIG}/${merchantId}`,
      );
      if (response?.data) {
        setDriverFeeConfig(response.data);
      }
    } catch (error) {
      console.error("Error fetching driver fee config:", error);
    }
  };

  useEffect(() => {
    fetchDriverFeeConfig();
  }, []);

  const handleRadioChangeNew = (value: string) => {
    setSelectedOption1(value);
    setCustomerDocTypeError("");
  };

  const handleBabySeatChange = (value: boolean) => {
    setBabySeatSelected(value);
    dispatch(setBookingValues({ ...bookingValues, babySeatSelected: value }));
    setIsButtonDisabled(false);
  };

  const handleAdditionalDriverChange = (value: boolean) => {
    setAdditionalDriverSelected(value);
    dispatch(
      setBookingValues({ ...bookingValues, additionalDriverSelected: value }),
    );
    setIsDriverButtonDisabled(false);
  };

  const handleWindShieldChange = (value: boolean) => {
    setWTPSelected(value);
    dispatch(setBookingValues({ ...bookingValues, wtpSelected: value }));
    setIsWTPButtonDisabled(false);
  };

  const handleScdwChange = (value: boolean) => {
    setSCDWSelected(value);
    dispatch(setBookingValues({ ...bookingValues, scdwSelected: value }));
  };

  const handleCdwChange = (value: boolean) => {
    setCDWSelected(value);
    dispatch(setBookingValues({ ...bookingValues, cdwSelected: value }));
  };

  // const handleCarRentalChange = (value: boolean) => {
  //   // setIsCarRentalAllowed(value);
  //   dispatch(setBookingValues({ ...bookingValues, isCarRentalAllowed: value }));
  // };
  const handleCarRentalChange = (newValue: boolean) => {
    setIsCarRentalAllowed(newValue);
    dispatch(
      setBookingValues({
        ...bookingValues,
        isCarRentalAllowed: newValue,
      }),
    );
  };

  const handleDataFromRentalSummary = (data: any) => {
    // Handle the received data here
    console.log("Data received from RentalSummary:", data);
  };

  const [selectedImage, setSelectedImage] = useState<string[]>([]);
  const [uploadedFile, setUploadedFile] = useState<string[]>([]);
  const [licenseFile, setLicenseFile] = useState<string[]>([]);
  const [emiratesIdFile, setEmiratesIdFile] = useState<string[]>([]);
  const [licenseFile2, setLicenseFile2] = useState<string[]>([]);
  const [VisitVisaFile, setVisitVisaFile] = useState<string[]>([]);
  const [PassportFile, setPassportFile] = useState<string[]>([]);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const fileInputRefLicense = useRef<HTMLInputElement>(null);
  const fileInputRefEmiratesId = useRef<HTMLInputElement>(null);
  const fileInputRefLicense2 = useRef<HTMLInputElement>(null);
  const fileInputRefVisitVisa = useRef<HTMLInputElement>(null);
  const fileInputRefPassport = useRef<HTMLInputElement>(null);

  const fileInputRefCameraLicense = useRef<HTMLInputElement>(null);
  const fileInputRefCameraEmiratesId = useRef<HTMLInputElement>(null);
  const fileInputRefCameraLicense2 = useRef<HTMLInputElement>(null);
  const fileInputRefCameraVisitVisa = useRef<HTMLInputElement>(null);
  const fileInputRefCameraPassport = useRef<HTMLInputElement>(null);

  const openFileInputLicense = () => {
    fileInputRefLicense?.current?.click();
  };
  const openFileInputCameraLicense = (event: {
    preventDefault: () => void;
  }) => {
    event?.preventDefault();
    fileInputRefCameraLicense?.current?.click();
  };
  const openFileInputEmiratesId = () => {
    fileInputRefEmiratesId?.current?.click();
  };
  const openFileInputCameraEmiratesId = (event: {
    preventDefault: () => void;
  }) => {
    event?.preventDefault();
    fileInputRefCameraEmiratesId?.current?.click();
  };

  const openFileInputLicense2 = () => {
    fileInputRefLicense2?.current?.click();
  };
  const openFileInputCameraLicense2 = (event: {
    preventDefault: () => void;
  }) => {
    event?.preventDefault();
    fileInputRefCameraLicense2?.current?.click();
  };

  const openFileInputVisitVisa = () => {
    fileInputRefVisitVisa?.current?.click();
  };
  const openFileInputCameraVisitVisa = (event: {
    preventDefault: () => void;
  }) => {
    event?.preventDefault();
    fileInputRefCameraVisitVisa?.current?.click();
  };

  const openFileInputPassport = () => {
    fileInputRefPassport?.current?.click();
  };

  const openFileInputCameraPassport = (event: {
    preventDefault: () => void;
  }) => {
    event?.preventDefault();
    fileInputRefCameraPassport?.current?.click();
  };
  const dispatch = useDispatch();



  const handleFileChangeEmiratesId = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (e.target.files) {
      const allowedExtensions = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
      const acceptedFiles = Array.from(e.target.files).filter((file) => {
        const fileExtension = file.name.split(".").pop()?.toLowerCase();
        if (fileExtension && allowedExtensions.includes(fileExtension)) {
          return true;
        }
        toast.error(`File ${file.name} is not supported. Please upload PDF, DOC, DOCX, JPG, JPEG, or PNG.`);
        return false;
      });

      if (acceptedFiles.length === 0) return;

      setEmiratesIdFileError("");
      const updatedImages = [...selectedImage];
      const updatedUUIDs = [...uploadedFile];
      const selectedFileNames = acceptedFiles.map((file) => file.name);

      setEmiratesIdFile((prevFiles) => [...prevFiles, ...selectedFileNames]);

      acceptedFiles.forEach((file) => {
        const dynamicDocType =
          emiratesUploadCount === 0
            ? "EMIRITIES"
            : `EMIRITIES${emiratesUploadCount}`;
        updatedImages.push(dynamicDocType || "");
        setEmiratesUploadCount(emiratesUploadCount + 1);
      });

      setSelectedImage(updatedImages);

      const dataTransfer = new DataTransfer();
      acceptedFiles.forEach((file) => {
        dataTransfer.items.add(file);
      });

      mutate(dataTransfer.files, {
        onSettled: () => {
          if (fileInputRefEmiratesId.current) fileInputRefEmiratesId.current.value = "";
          if (fileInputRefCameraEmiratesId.current) fileInputRefCameraEmiratesId.current.value = "";
        }
      });
    }
  };

  const handleFileChangeLicense2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const allowedExtensions = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
      const acceptedFiles = Array.from(e.target.files).filter((file) => {
        const fileExtension = file.name.split(".").pop()?.toLowerCase();
        if (fileExtension && allowedExtensions.includes(fileExtension)) {
          return true;
        }
        toast.error(`File ${file.name} is not supported. Please upload PDF, DOC, DOCX, JPG, JPEG, or PNG.`);
        return false;
      });

      if (acceptedFiles.length === 0) return;

      setLicenseFile2Error("");
      const updatedImages = [...selectedImage];
      const updatedUUIDs = [...uploadedFile];
      const selectedFileNames = acceptedFiles.map((file) => file.name);

      setLicenseFile2((prevFiles) => [...prevFiles, ...selectedFileNames]);

      acceptedFiles.forEach((file) => {
        const dynamicDocType =
          licenseUploadCount === 0 ? "LICENSE" : `LICENSE${licenseUploadCount}`;
        updatedImages.push(dynamicDocType || "");
        setLicenseUploadCount(licenseUploadCount + 1);
      });

      setSelectedImage(updatedImages);

      const dataTransfer = new DataTransfer();
      acceptedFiles.forEach((file) => {
        dataTransfer.items.add(file);
      });

      mutate(dataTransfer.files, {
        onSettled: () => {
          if (fileInputRefLicense2.current) fileInputRefLicense2.current.value = "";
          if (fileInputRefCameraLicense2.current) fileInputRefCameraLicense2.current.value = "";
        }
      });
    }
  };
  const handleFileChangeVisitVisa = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (e.target.files) {
      const allowedExtensions = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
      const acceptedFiles = Array.from(e.target.files).filter((file) => {
        const fileExtension = file.name.split(".").pop()?.toLowerCase();
        if (fileExtension && allowedExtensions.includes(fileExtension)) {
          return true;
        }
        toast.error(`File ${file.name} is not supported. Please upload PDF, DOC, DOCX, JPG, JPEG, or PNG.`);
        return false;
      });

      if (acceptedFiles.length === 0) return;

      setVisitVisaFileError("");
      const updatedImages = [...selectedImage];
      const updatedUUIDs = [...uploadedFile];
      const selectedFileNames = acceptedFiles.map((file) => file.name);

      setVisitVisaFile((prevFiles) => [...prevFiles, ...selectedFileNames]);

      acceptedFiles.forEach((file) => {
        const dynamicDocType =
          visaUploadCount === 0 ? "VisitVisa" : `VisitVisa${visaUploadCount}`;
        updatedImages.push(dynamicDocType || "");
        setVisaUploadCount(visaUploadCount + 1);
      });

      setSelectedImage(updatedImages);

      const dataTransfer = new DataTransfer();
      acceptedFiles.forEach((file) => {
        dataTransfer.items.add(file);
      });

      mutate(dataTransfer.files, {
        onSettled: () => {
          if (fileInputRefVisitVisa.current) fileInputRefVisitVisa.current.value = "";
          if (fileInputRefCameraVisitVisa.current) fileInputRefCameraVisitVisa.current.value = "";
        }
      });
    }
  };
  const handleFileChangePassport = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const allowedExtensions = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
      const acceptedFiles = Array.from(e.target.files).filter((file) => {
        const fileExtension = file.name.split(".").pop()?.toLowerCase();
        if (fileExtension && allowedExtensions.includes(fileExtension)) {
          return true;
        }
        toast.error(`File ${file.name} is not supported. Please upload PDF, DOC, DOCX, JPG, JPEG, or PNG.`);
        return false;
      });

      if (acceptedFiles.length === 0) return;

      setPassportFileError("");
      const updatedImages = [...selectedImage];
      const updatedUUIDs = [...uploadedFile];
      const selectedFileNames = acceptedFiles.map((file) => file.name);

      setPassportFile((prevFiles) => [...prevFiles, ...selectedFileNames]);

      acceptedFiles.forEach((file) => {
        const dynamicDocType =
          passportUploadCount === 0
            ? "Passport"
            : `Passport${passportUploadCount}`;
        updatedImages.push(dynamicDocType || "");
        setPassportUploadCount(passportUploadCount + 1);
      });

      setSelectedImage(updatedImages);

      const dataTransfer = new DataTransfer();
      acceptedFiles.forEach((file) => {
        dataTransfer.items.add(file);
      });

      mutate(dataTransfer.files, {
        onSettled: () => {
          if (fileInputRefPassport.current) fileInputRefPassport.current.value = "";
          if (fileInputRefCameraPassport.current) fileInputRefCameraPassport.current.value = "";
        }
      });
    }
  };

  const handleDeleteImageLicense = (index: number) => {
    setValue("residentsLicenseNumber", "");
    setExpiryDate(undefined);
    setExpiryError("");

    // Reset file input to allow re-uploading the same file
    if (fileInputRefLicense.current) {
      fileInputRefLicense.current.value = "";
    }
    if (fileInputRefCameraLicense.current) {
      fileInputRefCameraLicense.current.value = "";
    }

    setLicenseFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      setSelectedImage((prevImages) => {
        const updatedImages = [...prevImages];
        if (index < prevImages.length) {
          updatedImages.splice(index, 1);
        }
        return updatedImages;
      });
      setUploadedFile((prevUUIDs) => {
        const updatedUUIDs = [...prevUUIDs];
        if (index < prevUUIDs.length) {
          updatedUUIDs.splice(index, 1);
        }
        return updatedUUIDs;
      });
      return updatedFiles;
    });
  };
  const handleDeleteImageEmiratesId = (index: number) => {
    // Reset file input to allow re-uploading the same file
    if (fileInputRefEmiratesId.current) {
      fileInputRefEmiratesId.current.value = "";
    }
    if (fileInputRefCameraEmiratesId.current) {
      fileInputRefCameraEmiratesId.current.value = "";
    }

    setEmiratesIdFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      setSelectedImage((prevImages) => {
        const updatedImages = [...prevImages];
        if (index < prevImages.length) {
          updatedImages.splice(index, 1);
        }
        return updatedImages;
      });
      setUploadedFile((prevUUIDs) => {
        const updatedUUIDs = [...prevUUIDs];
        if (index < prevUUIDs.length) {
          updatedUUIDs.splice(index, 1);
        }
        return updatedUUIDs;
      });
      return updatedFiles;
    });
  };
  const handleDeleteImageLicense2 = (index: number) => {
    // Reset file input to allow re-uploading the same file
    if (fileInputRefLicense2.current) {
      fileInputRefLicense2.current.value = "";
    }
    if (fileInputRefCameraLicense2.current) {
      fileInputRefCameraLicense2.current.value = "";
    }

    setLicenseFile2((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      setSelectedImage((prevImages) => {
        const updatedImages = [...prevImages];
        if (index < prevImages.length) {
          updatedImages.splice(index, 1);
        }
        return updatedImages;
      });
      setUploadedFile((prevUUIDs) => {
        const updatedUUIDs = [...prevUUIDs];
        if (index < prevUUIDs.length) {
          updatedUUIDs.splice(index, 1);
        }
        return updatedUUIDs;
      });
      return updatedFiles;
    });
  };
  const handleDeleteImageVisitVisa = (index: number) => {
    // Reset file input to allow re-uploading the same file
    if (fileInputRefVisitVisa.current) {
      fileInputRefVisitVisa.current.value = "";
    }
    if (fileInputRefCameraVisitVisa.current) {
      fileInputRefCameraVisitVisa.current.value = "";
    }

    setVisitVisaFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      setSelectedImage((prevImages) => {
        const updatedImages = [...prevImages];
        if (index < prevImages.length) {
          updatedImages.splice(index, 1);
        }
        return updatedImages;
      });
      setUploadedFile((prevUUIDs) => {
        const updatedUUIDs = [...prevUUIDs];
        if (index < prevUUIDs.length) {
          updatedUUIDs.splice(index, 1);
        }
        return updatedUUIDs;
      });
      return updatedFiles;
    });
  };
  const handleDeleteImagePassport = (index: number) => {
    // Reset file input to allow re-uploading the same file
    if (fileInputRefPassport.current) {
      fileInputRefPassport.current.value = "";
    }
    if (fileInputRefCameraPassport.current) {
      fileInputRefCameraPassport.current.value = "";
    }

    setPassportFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      setSelectedImage((prevImages) => {
        const updatedImages = [...prevImages];
        if (index < prevImages.length) {
          updatedImages.splice(index, 1);
        }
        return updatedImages;
      });
      setUploadedFile((prevUUIDs) => {
        const updatedUUIDs = [...prevUUIDs];
        if (index < prevUUIDs.length) {
          updatedUUIDs.splice(index, 1);
        }
        return updatedUUIDs;
      });
      return updatedFiles;
    });
  };

  const { mutate } = useMutation({
    mutationFn: (fileList: FileList) => {
      const formData = new FormData();
      Array.from(fileList).forEach((file) => {
        formData.append("document", file);
      });
      return axiosInstance.post(API_URL.DOC_UPLOAD, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (response) => {
      const uuid = response?.data?.uuid || null;
      setUploadedFile((prevUUIDs) => [...prevUUIDs, uuid]);
      setUploadSuccess(true);
      toast.success("Updated successfully!", {
        position: "top-right",
      });
    },
    onError: (error) => {
      console.error("Error uploading images", error);
      setUploadSuccess(false);
      toast.error("Error updating data. Please try again.", {
        position: "top-right",
      });
    },
  });

  const handleFileChangeLicense = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const allowedExtensions = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
      const acceptedFiles = Array.from(e.target.files).filter((file) => {
        const fileExtension = file.name.split(".").pop()?.toLowerCase();
        if (fileExtension && allowedExtensions.includes(fileExtension)) {
          return true;
        }
        toast.error(`File ${file.name} is not supported. Please upload PDF, DOC, DOCX, JPG, JPEG, or PNG.`);
        return false;
      });

      if (acceptedFiles.length === 0) return;

      setIsLicenseLoading(true);
      setLicenseFileError("");
      const selectedFileNames = acceptedFiles.map((file) => file.name);

      const dataTransfer = new DataTransfer();
      acceptedFiles.forEach((file) => {
        dataTransfer.items.add(file);
      });

      const formData = new FormData();
      formData.append("file", dataTransfer.files[0]);

      let shouldUpload = true;

      try {
        const ocrResponse = await axiosInstance.post(
          `${API_URL.OCR}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("OCR Response:", ocrResponse.data);

        if (ocrResponse.data) {
          const { license_number, expiry_date, status } = ocrResponse.data;

          if (status === "Expired") {
            toast.error("License is expired. Please upload a valid license.", {
              position: "top-right",
            });
            setExpiryError("License is expired. Please upload a valid license.");
            setValue("residentsLicenseNumber", "");
            setExpiryDate(undefined);
            shouldUpload = false;
          } else {
            if (license_number) {
              setValue("residentsLicenseNumber", license_number);
            }

            if (expiry_date) {
              const parts = expiry_date.split("/");
              if (parts.length === 3) {
                const day = parseInt(parts[0], 10);
                const month = parseInt(parts[1], 10) - 1;
                const year = parseInt(parts[2], 10);
                const dateObj = new Date(year, month, day);

                if (!isNaN(dateObj.getTime())) {
                  handleExpiryDateChange(dateObj);
                }
              }
            }
            toast.success("License information extracted successfully!", {
              position: "top-right",
            });
          }
        }
      } catch (ocrError) {
        console.error("OCR API Error:", ocrError);
        // toast.error("Failed to extract license information. Please verify the image quality.", {
        //   position: "top-right",
        // });
      } finally {
        if (!shouldUpload) {
          setIsLicenseLoading(false);
        }
      }

      if (shouldUpload) {
        // Update State
        setLicenseFile((prevFiles) => [...prevFiles, ...selectedFileNames]);

        const newDocTypes: string[] = [];

        // Note: using closure value of licenseUploadCount. 
        // Since we are inside the same render closure, it is the value at start of function.
        let currentUploadCount = licenseUploadCount;

        acceptedFiles.forEach((file) => {
          const dynamicDocType =
            currentUploadCount === 0 ? "LICENSE" : `LICENSE${currentUploadCount}`;
          newDocTypes.push(dynamicDocType || "");
          currentUploadCount++;
        });

        setLicenseUploadCount((prev) => prev + acceptedFiles.length);

        setSelectedImage((prevImages) => [...prevImages, ...newDocTypes]);

        // Proceed to upload document
        mutate(dataTransfer.files, {
          onSettled: () => {
            setIsLicenseLoading(false);
            // Reset file input to allow re-uploading the same file
            if (fileInputRefLicense.current) {
              fileInputRefLicense.current.value = "";
            }
            if (fileInputRefCameraLicense.current) {
              fileInputRefCameraLicense.current.value = "";
            }
          }
        });
      }
    }
  };

  const onHandleSubmitLicense = () => {
    const formattedExpiryDate = selectedOption1 === "Tourists"
      ? (touristExpiryDate || "")
      : (expiryDate || "");

    const values = getValues();
    const licence_number = selectedOption1 === "UAE Residents"
      ? values.residentsLicenseNumber
      : values.touristsLicenseNumber;


    const imagesData = selectedImage.map((docType, index) => ({
      docType: docType,
      docId: uploadedFile[index],
    }));
    const userData: DocumentDetails = {
      licence_number,
      licence_expiry_date: formattedExpiryDate,
      last_level: 999,
      customerDocs: imagesData,
    };

    if (selectedOption1 === "UAE Residents") {
      userData.emirates_id = values.residentsEmiratesIdNumber;
    }
    console.log("Expiry Date:", expiryDate);

    handleRegistration.mutate(userData);
  };

  const handleRegistration = useMutation({
    mutationFn: (userData: DocumentDetails) =>
      axiosInstance.put(API_URL.SIGNUP_MERCHANT, userData),
    onSuccess: (successResponse) => {
      console.log("successResponse", successResponse);
      if (successResponse.status && successResponse?.data?.message) {
      }
    },
    onError: (error: any) => {
      if (error?.data?.message) {
      }
    },
  });

  useEffect(() => {
    if (!location.state) {
      navigate("/customer/myaccount", { replace: true });
      return;
    }
  }, [location.state, navigate]);

  useEffect(() => {
    const trackPageLoad = async () => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("ViewContent", {
        content_type: "page",
        content_name: "Additional Options Screen",
        content_category: "RentACarBook",
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_RentACar_AdditionalOptionsScreen",
          app: "Kirkos_RentACar_AdditionalOptionsScreen_App",
        },
        event_category: "RentACarBook_Info",
        module: "BookNow",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  const {
    data: customerData,
    // isLoading,
    // isError,
    // error,
  } = useQuery<CustomerDetails, Error>({
    queryKey: ["details"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.CUSTOMER_DETAILS);
      console.log(response, "response");
      return response.data;
    },
    enabled: !!location.state,
    retry: false,
    staleTime: 0,
    refetchOnMount: true,
  });

  const { data: optionsList } = useQuery<any, Error>({
    queryKey: ["optionsList"],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.ADDITIONAL_OPTIONS}/${merchantId}`,
      );
      console.log(response, "Optionsresponse");
      return response.data;
    },
    enabled: !!location.state?.merchantId,
    retry: false,
    staleTime: 0,
    refetchOnMount: true,
  });
  useEffect(() => {
    if (!location.state) return;

    const { selectedItem } = location.state;
    console.log(selectedItem, "selectedItem");
    if (optionsList || selectedItem) {
      if (selectedItem?.product_details_car?.child_seat_amount !== 0) {
        setBabySeatSelected(bookingValues?.babySeatSelected ?? false);
      }
      if (optionsList?.additionalDriver) {
        setAdditionalDriverSelected(
          bookingValues?.additionalDriverSelected ?? false,
        );
      }
      if (
        selectedItem?.product_details_car?.personal_accident_insurance_model
          ?.daily_personal_accident_insurance !== 0
      ) {
        setIsCarRentalAllowed(bookingValues?.isCarRentalAllowed ?? false);
      }
      if (selectedItem?.product_details_car?.wind_shield_protection) {
        setWTPSelected(bookingValues?.wtpSelected ?? false);
      }
      if (
        selectedItem?.product_details_car?.super_collision_damage_waiver_model
          ?.daily_super_collision_damage_waiver !== 0
      ) {
        setSCDWSelected(bookingValues?.scdwSelected ?? false);
      }
      if (
        selectedItem?.product_details_car?.collision_damage_waiver_model
          ?.daily_collision_damage_waiver !== 0
      ) {
        setCDWSelected(bookingValues?.cdwSelected ?? false);
      }
    }
  }, [optionsList, location.state, bookingValues]);

  if (!location.state) {
    return null;
  }

  const { deliveryDetails, selectedItem, merchantId, searchData } =
    location.state;

  const rentalTotalVat: number = selectedItem?.product_details_car?.totalVat ?? 0;

  const rentalTotalStripeFeeFinal: number = selectedItem?.product_details_car?.totalStripeFeeFinal ?? 0;

  //------------------------
  const daysDifference = deliveryDetails?.daysDifference;

  const getRentalTypeAndMultiplier = (days: number) => {
    if (days % 30 === 0) {
      return { type: "MONTHLY", multiplier: days / 30 };
    } else if (days % 7 === 0) {
      return { type: "WEEKLY", multiplier: days / 7 };
    } else {
      return { type: "DAILY", multiplier: days };
    }
  };

  const getAdditionalDriverFee = () => {
    if (!daysDifference || !driverFeeConfig.length) return 0;

    const { type, multiplier } = getRentalTypeAndMultiplier(daysDifference);
    const feeConfig = driverFeeConfig.find(
      (config) =>
        config.frequency === type && config.merchant_id === merchantId,
    );

    if (!feeConfig) {
      console.log("No fee config found for", { type, merchantId });
      return 0;
    }

    const totalFee = Math.floor(feeConfig.amount * multiplier);
    console.log("Fee calculation:", {
      frequency: feeConfig.frequency,
      amount: feeConfig.amount,
      multiplier,
      totalFee,
    });

    return totalFee;
  };

  let cdw_Amount = 0;
  if (bookingValues?.cdwSelected && daysDifference) {
    const months = Math.floor(daysDifference / 30);
    const remainderAfterMonths = daysDifference % 30;
    const weeks = Math.floor(remainderAfterMonths / 7);
    const days = remainderAfterMonths % 7;

    const cdwModel =
      selectedItem?.product_details_car?.collision_damage_waiver_model;

    cdw_Amount =
      months * (cdwModel?.monthly_collision_damage_waiver ?? 0) +
      weeks * (cdwModel?.weekly_collision_damage_waiver ?? 0) +
      days * (cdwModel?.daily_collision_damage_waiver ?? 0);
  }

  let scdw_Amount = 0;
  if (bookingValues?.scdwSelected && daysDifference) {
    const months = Math.floor(daysDifference / 30);
    const remainderAfterMonths = daysDifference % 30;
    const weeks = Math.floor(remainderAfterMonths / 7);
    const days = remainderAfterMonths % 7;

    const cdwModel =
      selectedItem?.product_details_car?.super_collision_damage_waiver_model;

    scdw_Amount =
      months * (cdwModel?.monthly_super_collision_damage_waiver ?? 0) +
      weeks * (cdwModel?.weekly_super_collision_damage_waiver ?? 0) +
      days * (cdwModel?.daily_super_collision_damage_waiver ?? 0);
  }

  let pai_InsuranceAmount = 0;
  if (bookingValues?.isCarRentalAllowed && daysDifference) {
    const months = Math.floor(daysDifference / 30);
    const remainderAfterMonths = daysDifference % 30;
    const weeks = Math.floor(remainderAfterMonths / 7);
    const days = remainderAfterMonths % 7;

    const cdwModel =
      selectedItem?.product_details_car?.personal_accident_insurance_model;

    pai_InsuranceAmount =
      months * (cdwModel?.monthly_personal_accident_insurance ?? 0) +
      weeks * (cdwModel?.weekly_personal_accident_insurance ?? 0) +
      days * (cdwModel?.daily_personal_accident_insurance ?? 0);
  }

  let wtpAmount = 0;
  if (bookingValues?.wtpSelected && daysDifference) {
    const wtpDailyRate =
      selectedItem?.product_details_car?.wind_shield_protection;
    wtpAmount = wtpDailyRate * daysDifference;
  }

  let babySeatAmount = 0;
  if ((bookingValues?.babySeatSelected ?? babySeatSelected) && daysDifference) {
    const babySeatDailyRate =
      selectedItem?.product_details_car?.child_seat_amount;
    babySeatAmount = babySeatDailyRate * daysDifference;
  }

  let additionalDriverFeeAmount = 0;
  if (
    (bookingValues?.additionalDriverSelected ?? additionalDriverSelected) &&
    daysDifference
  ) {
    const driverDailyRate =
      driverFeeConfig.find(
        (config) =>
          config.frequency ===
          getRentalTypeAndMultiplier(daysDifference).type &&
          config.merchant_id === merchantId,
      )?.amount ?? 0;
    additionalDriverFeeAmount = driverDailyRate * daysDifference;
  }

  //---------------------

  const onHandleSubmit = async () => {
    let paiInsuranceAmount = 0.0;

    if (isCarRentalAllowed) {
      paiInsuranceAmount =
        selectedItem?.product_details_car?.personal_accident_insurance_model
          ?.daily_personal_accident_insurance;
    }

    let scdwAmount = 0.0;
    let cdwAmount = 0.0;
    let scdwFlag = false;
    let cdwFlag = false;
    if (scdwSelected) {
      scdwAmount =
        selectedItem?.product_details_car?.super_collision_damage_waiver_model
          ?.daily_super_collision_damage_waiver;
      scdwFlag = true;
      cdwFlag = false;
    }
    if (cdwSelected) {
      cdwAmount =
        selectedItem?.product_details_car?.collision_damage_waiver_model
          ?.daily_collision_damage_waiver;
      cdwFlag = true;
      scdwFlag = false;
    }
    const optionalData = {
      baby_seat: bookingValues?.babySeatSelected ?? babySeatSelected,
      baby_seat_amount:
        (bookingValues?.babySeatSelected ?? babySeatSelected)
          ? selectedItem?.product_details_car?.child_seat_amount
          : 0,
      additional_driver:
        bookingValues?.additionalDriverSelected ?? additionalDriverSelected,
      additional_driver_amount:
        (bookingValues?.additionalDriverSelected ?? additionalDriverSelected)
          ? getAdditionalDriverFee()
          : 0,
      pai_insurance_amount:
        (bookingValues?.isCarRentalAllowed ?? isCarRentalAllowed)
          ? selectedItem?.product_details_car?.personal_accident_insurance_model
            ?.daily_personal_accident_insurance
          : 0,
      weekly_pai_insurance_amount:
        (bookingValues?.isCarRentalAllowed ?? isCarRentalAllowed)
          ? selectedItem?.product_details_car?.personal_accident_insurance_model
            ?.weekly_personal_accident_insurance
          : 0,
      monthly_pai_insurance_amount:
        (bookingValues?.isCarRentalAllowed ?? isCarRentalAllowed)
          ? selectedItem?.product_details_car?.personal_accident_insurance_model
            ?.monthly_personal_accident_insurance
          : 0,
      // SCDW rates
      scdw_amount:
        (bookingValues?.scdwSelected ?? scdwSelected)
          ? selectedItem?.product_details_car
            ?.super_collision_damage_waiver_model
            ?.daily_super_collision_damage_waiver
          : 0,
      weekly_scdw_amount:
        (bookingValues?.scdwSelected ?? scdwSelected)
          ? selectedItem?.product_details_car
            ?.super_collision_damage_waiver_model
            ?.weekly_super_collision_damage_waiver
          : 0,
      monthly_scdw_amount:
        (bookingValues?.scdwSelected ?? scdwSelected)
          ? selectedItem?.product_details_car
            ?.super_collision_damage_waiver_model
            ?.monthly_super_collision_damage_waiver
          : 0,
      // CDW rates
      cdw_amount:
        (bookingValues?.cdwSelected ?? cdwSelected)
          ? selectedItem?.product_details_car?.collision_damage_waiver_model
            ?.daily_collision_damage_waiver
          : 0,
      weekly_cdw_amount:
        (bookingValues?.cdwSelected ?? cdwSelected)
          ? selectedItem?.product_details_car?.collision_damage_waiver_model
            ?.weekly_collision_damage_waiver
          : 0,
      monthly_cdw_amount:
        (bookingValues?.cdwSelected ?? cdwSelected)
          ? selectedItem?.product_details_car?.collision_damage_waiver_model
            ?.monthly_collision_damage_waiver
          : 0,
      cdw_flag: bookingValues?.cdwSelected ?? cdwSelected,
      scdw_flag: bookingValues?.scdwSelected ?? scdwSelected,
      wind_shield_protection:
        (bookingValues?.wtpSelected ?? wtpSelected)
          ? selectedItem?.product_details_car?.wind_shield_protection
          : 0,
    };

    if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
      ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
    }
    ReactPixel.track("InitiateCheckout", {
      content_type: "additional_options",
      content_name: "Additional Options Selected",
      content_category: "RentACarBook",
      baby_seat: optionalData.baby_seat,
      additional_driver: optionalData.additional_driver,
      cdw_flag: optionalData.cdw_flag,
      scdw_flag: optionalData.scdw_flag,
    });
    await trackEvent({
      event_name: {
        web: "Kirkos_RentACar_AdditionalOptions_Success",
        app: "Kirkos_RentACar_AdditionalOptions_Success_App",
      },
      event_category: "RentACarBook_Info",
      module: "BookNow",
      payload: {
        status: "success",
        baby_seat: optionalData.baby_seat,
        baby_seat_amount: babySeatAmount,
        additional_driver: optionalData.additional_driver,
        cdw_flag: optionalData.cdw_flag,
        scdw_flag: optionalData.scdw_flag,
      },
    });

    navigate("/customer/vehicleinspection", {
      state: {
        deliveryDetails,
        optionalData,
        selectedItem,
        merchantId,
        searchData,
        additionalDriverFee: additionalDriverFeeAmount,
        babySeatAmount,
        cdw_Amount,
        scdw_Amount,
        pai_InsuranceAmount,
      },
    });
  };

  const handleExpiryDateChange = (date: Date) => {
    if (date) {
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

      if (date == oneYearLater) {
        setExpiryError(
          "Expiry date must be at least one year from the current date.",
        );
      } else {
        setExpiryDate(date.toISOString());
        setExpiryError("");
      }
    } else {
      setExpiryDate("");
      setExpiryError("");
    }
  };

  const handleTouristExpiryDateChange = (date: Date) => {
    if (date) {
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

      if (date == oneYearLater) {
        setTouristExpiryError(
          "Expiry date must be at least one year from the current date.",
        );
      } else {
        setTouristExpiryDate(date.toISOString());
        setTouristExpiryError("");
      }
    } else {
      setTouristExpiryDate("");
      setTouristExpiryError("");
    }
  };

  const validateAndSubmit = async () => {
    if (Object.keys(customerData?.customerDocs || {}).length > 0) {
      handleCombinedSubmit();
      return;
    }

    const isFormValid = await trigger();
    let isCustomValid = true;

    if (!selectedOption1) {
      toast.error("Please select either the UAE Residents or Tourists option.");
      isCustomValid = false;
    }

    if (selectedOption1 === "UAE Residents") {
      if (!expiryDate) {
        setExpiryError("Expiry Date is required");
        isCustomValid = false;
      }
      if (licenseFile.length === 0) {
        setLicenseFileError("License copy is required");
        isCustomValid = false;
      }
      if (emiratesIdFile.length === 0) {
        setEmiratesIdFileError("Emirates ID copy is required");
        isCustomValid = false;
      }
    } else if (selectedOption1 === "Tourists") {
      if (!touristExpiryDate) {
        setTouristExpiryError("Expiry Date is required");
        isCustomValid = false;
      }
      if (licenseFile2.length === 0) {
        setLicenseFile2Error("License copy is required");
        isCustomValid = false;
      }
      if (VisitVisaFile.length === 0) {
        setVisitVisaFileError("Visit Visa copy is required");
        isCustomValid = false;
      }
      if (PassportFile.length === 0) {
        setPassportFileError("Passport copy is required");
        isCustomValid = false;
      }
    }

    if (isFormValid && isCustomValid) {
      handleCombinedSubmit();
    } else if (!isCustomValid && docsErrorSectionRef.current) {
      docsErrorSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleCombinedSubmit = () => {
    onHandleSubmitLicense();
    onHandleSubmit();
  };

  const handleBack = () => {
    navigate("/customer/bpnonholder", {
      state: location.state
    });
  };

  return (
    <div className="row g-4 non-insurance-second-container">
      <div className="col-lg-8 non-insurance-second-form-section">
        <div className="card card-custom">
          <div className="card-body">
            {/* Page Title */}
            <div className="d-flex align-items-center gap-3 mb-5">
              <img src={car_key} alt="" className="header-icon" />
              <h1 className="page-head-add mb-0">Customize Your Booking</h1>
            </div>

            {/* Additional Options Section */}
            {(selectedItem?.product_details_car?.child_seat_amount || optionsList?.additionalDriver || selectedItem?.product_details_car?.wind_shield_protection) && (
              <div className="mb-5">
                <div className="d-flex align-items-center gap-2 mb-4">
                  <div className="section-header-bar"></div>
                  <h2 className="page-head-add fs-5 mb-0">Extra Services</h2>
                </div>
                <div className="options-grid">
                  {selectedItem?.product_details_car?.child_seat_amount !== 0 && (
                    <div
                      className={`option-card ${bookingValues?.babySeatSelected ? 'selected' : ''}`}
                      onClick={() => handleBabySeatChange(!bookingValues?.babySeatSelected)}
                    >
                      <div style={{ pointerEvents: 'none' }}>
                        <CustomCheckBox
                          onChange={() => { }} // Controlled by card click
                          isChecked={bookingValues?.babySeatSelected === true}
                        />
                      </div>
                      <div className="option-content">
                        <img src={baby_seat} alt="" className="header-icon mb-2" />
                        <div className="non_insur_per_day_aed">
                          AED {(() => {
                            const perDayRate = selectedItem?.product_details_car?.child_seat_amount || 0;
                            const commission = perDayRate * 0.05;
                            const vat = (perDayRate + commission) * 0.05;
                            const sum = perDayRate + commission + vat;
                            const stripeFee = sum * 0.0299;
                            const stripeVat = isStripeFeeEnabled ? stripeFee * 0.05 : 0;
                            const finalAmount = sum + stripeFee + stripeVat;
                            return Math.round(finalAmount - vat).toString();
                          })()} / day
                        </div>
                        <div className="radio-label-noninsurence">Baby Seat</div>
                      </div>
                    </div>
                  )}

                  {optionsList?.additionalDriver && (
                    <div
                      className={`option-card ${bookingValues?.additionalDriverSelected ? 'selected' : ''}`}
                      onClick={() => handleAdditionalDriverChange(!bookingValues?.additionalDriverSelected)}
                    >
                      <div style={{ pointerEvents: 'none' }}>
                        <CustomCheckBox
                          onChange={() => { }}
                          isChecked={bookingValues?.additionalDriverSelected === true}
                        />
                      </div>
                      <div className="option-content">
                        <img src={steering_wheel} alt="" className="header-icon mb-2" />
                        <div className="non_insur_per_day_aed">
                          AED {(() => {
                            const perDayRate = driverFeeConfig.find(
                              (config) => config.frequency === getRentalTypeAndMultiplier(daysDifference || 0).type
                            )?.amount || 0;
                            const commission = perDayRate * 0.05;
                            const vat = (perDayRate + commission) * 0.05;
                            const sum = perDayRate + commission + vat;
                            const stripeFee = sum * 0.0299;
                            const stripeVat = isStripeFeeEnabled ? stripeFee * 0.05 : 0;
                            const finalAmount = sum + stripeFee + stripeVat;
                            return Math.round(finalAmount - vat).toString();
                          })()} / day
                        </div>
                        <div className="radio-label-noninsurence">Additional Driver</div>
                      </div>
                    </div>
                  )}

                  {selectedItem?.product_details_car?.wind_shield_protection !== 0 && (
                    <div
                      className={`option-card ${bookingValues?.wtpSelected ? 'selected' : ''}`}
                      onClick={() => handleWindShieldChange(!bookingValues?.wtpSelected)}
                    >
                      <div style={{ pointerEvents: 'none' }}>
                        <CustomCheckBox
                          onChange={() => { }}
                          isChecked={bookingValues?.wtpSelected === true}
                        />
                      </div>
                      <div className="option-content">
                        <img src={wind_shield_protection_icon} alt="" className="header-icon mb-2" />
                        <div className="non_insur_per_day_aed">
                          AED {(() => {
                            const perDayRate = selectedItem?.product_details_car?.wind_shield_protection || 0;
                            const commission = perDayRate * 0.05;
                            const vat = (perDayRate + commission) * 0.05;
                            const sum = perDayRate + commission + vat;
                            const stripeFee = sum * 0.0299;
                            const stripeVat = isStripeFeeEnabled ? stripeFee * 0.05 : 0;
                            const finalAmount = sum + stripeFee + stripeVat;
                            return Math.round(finalAmount - vat).toString();
                          })()} / day
                        </div>
                        <div className="radio-label-noninsurence">Windshield Protection</div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Insurance Section */}
            <div className="mb-5">
              <div className="d-flex align-items-center gap-2 mb-4">
                <div className="section-header-bar"></div>
                <h2 className="page-head-add fs-5 mb-0">Insurance Coverage</h2>
              </div>
              <div className="options-grid">
                {selectedItem?.product_details_car?.personal_accident_insurance_model?.daily_personal_accident_insurance !== 0 && (
                  <div
                    className={`option-card ${bookingValues?.isCarRentalAllowed ? 'selected' : ''}`}
                    onClick={() => handleCarRentalChange(!bookingValues?.isCarRentalAllowed)}
                  >
                    <div style={{ pointerEvents: 'none' }}>
                      <CustomCheckBox
                        onChange={() => { }}
                        isChecked={bookingValues?.isCarRentalAllowed === true}
                      />
                    </div>
                    <div className="option-content">
                      <img src={mdi_car_insurance} alt="" className="header-icon mb-2" />
                      <div className="non_insur_per_day_aed">
                        AED {(() => {
                          const rate = selectedItem?.product_details_car?.personal_accident_insurance_model?.daily_personal_accident_insurance || 0;
                          const commission = rate * 0.05;
                          const vat = (rate + commission) * 0.05;
                          const sum = rate + commission + vat;
                          const stripeFee = sum * 0.0299;
                          const stripeVat = isStripeFeeEnabled ? stripeFee * 0.05 : 0;
                          const finalAmount = sum + stripeFee + stripeVat;
                          return Math.round(finalAmount - vat).toString();
                        })()} / day
                      </div>
                      <div className="radio-label-noninsurence">PAI Insurance</div>
                    </div>
                  </div>
                )}

                {selectedItem?.product_details_car?.collision_damage_waiver_model?.daily_collision_damage_waiver !== 0 && (
                  <div
                    className={`option-card ${bookingValues?.cdwSelected ? 'selected' : ''}`}
                    onClick={() => handleCdwChange(!bookingValues?.cdwSelected)}
                  >
                    <div style={{ pointerEvents: 'none' }}>
                      <CustomCheckBox
                        onChange={() => { }}
                        isChecked={bookingValues?.cdwSelected === true}
                      />
                    </div>
                    <div className="option-content">
                      <img src={mdi_car_insurance} alt="" className="header-icon mb-2" />
                      <div className="non_insur_per_day_aed">
                        AED {(() => {
                          const cdwModel = selectedItem?.product_details_car?.collision_damage_waiver_model;
                          const calcDisplay = (rate: number) => {
                            const commission = rate * 0.05;
                            const vat = (rate + commission) * 0.05;
                            const sum = rate + commission + vat;
                            const stripeFee = sum * 0.0299;
                            const stripeVat = isStripeFeeEnabled ? stripeFee * 0.05 : 0;
                            const finalAmount = sum + stripeFee + stripeVat;
                            return Math.round(finalAmount - vat).toString();
                          };
                          if (daysDifference % 30 === 0 && daysDifference >= 30) {
                            return `${calcDisplay(cdwModel?.monthly_collision_damage_waiver || 0)} / mo`;
                          }
                          return `${calcDisplay(cdwModel?.daily_collision_damage_waiver || 0)} / day`;
                        })()}
                      </div>
                      <div className="radio-label-noninsurence">CDW Insurance</div>
                    </div>
                  </div>
                )}

                {selectedItem?.product_details_car?.super_collision_damage_waiver_model?.daily_super_collision_damage_waiver !== 0 && (
                  <div
                    className={`option-card ${bookingValues?.scdwSelected ? 'selected' : ''}`}
                    onClick={() => handleScdwChange(!bookingValues?.scdwSelected)}
                  >
                    <div style={{ pointerEvents: 'none' }}>
                      <CustomCheckBox
                        onChange={() => { }}
                        isChecked={bookingValues?.scdwSelected === true}
                      />
                    </div>
                    <div className="option-content">
                      <img src={mdi_car_insurance} alt="" className="header-icon mb-2" />
                      <div className="non_insur_per_day_aed">
                        AED {(() => {
                          const scdwModel = selectedItem?.product_details_car?.super_collision_damage_waiver_model;
                          const calcDisplay = (rate: number) => {
                            const commission = rate * 0.05;
                            const vat = (rate + commission) * 0.05;
                            const sum = rate + commission + vat;
                            const stripeFee = sum * 0.0299;
                            const stripeVat = isStripeFeeEnabled ? stripeFee * 0.05 : 0;
                            const finalAmount = sum + stripeFee + stripeVat;
                            return Math.round(finalAmount - vat).toString();
                          };
                          if (daysDifference % 30 === 0 && daysDifference >= 30) {
                            return `${calcDisplay(scdwModel?.monthly_super_collision_damage_waiver || 0)} / mo`;
                          }
                          return `${calcDisplay(scdwModel?.daily_super_collision_damage_waiver || 0)} / day`;
                        })()}
                      </div>
                      <div className="radio-label-noninsurence">SCDW Insurance</div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Document Upload Section */}
            {!Object.keys(customerData?.customerDocs || {}).length && customerData && (
              <div className="mb-4" ref={docsErrorSectionRef}>
                <div className="d-flex align-items-center gap-2 mb-4">
                  <div className="section-header-bar"></div>
                  <h2 className="page-head-add fs-5 mb-0">Identity & Documents <span className="text-danger">*</span></h2>
                </div>

                <div className="doc-selection-tabs">
                  <div
                    className={`doc-tab ${selectedOption1 === "UAE Residents" ? 'active' : ''}`}
                    onClick={() => handleRadioChangeNew("UAE Residents")}
                  >
                    <div className="res_license_num mb-0">UAE Residents</div>
                  </div>
                  <div
                    className={`doc-tab ${selectedOption1 === "Tourists" ? 'active' : ''}`}
                    onClick={() => handleRadioChangeNew("Tourists")}
                  >
                    <div className="res_license_num mb-0">Tourists</div>
                  </div>
                </div>

                {customerDocTypeError && (
                  <div className="text-danger mb-3 fw-bold">{customerDocTypeError}</div>
                )}

                <div className="row g-4">
                  {selectedOption1 === "UAE Residents" && (
                    <div className="col-12">
                      <div className="res_license_num mb-3 opacity-75">Document Uploads</div>
                      <div className="row g-4 mb-4">
                        <div className="col-12">
                          <div className="res_license_num">Driving License Copy <span className="text-danger">*</span></div>
                          <div className="upload-field-container">
                            {isLicenseLoading ? (
                              <div className="spinner-border text-warning" role="status"></div>
                            ) : (
                              <>
                                {licenseFile.length === 0 ? (
                                  <button className="btn-custom-upload" onClick={openFileInputLicense}>
                                    <Upload className="me-2" /> Browse Files
                                  </button>
                                ) : (
                                  <div className="mt-2 uploaded-files-list">
                                    {licenseFile.map((name, i) => (
                                      <div key={i} className="uploaded-file-item">
                                        <span className="file-name">{name}</span>
                                        <Trash className="delete-icon" onClick={() => handleDeleteImageLicense(i)} />
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            )}
                            <input type="file" ref={fileInputRefLicense} hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={handleFileChangeLicense} />
                            {licenseFileError && <div className="text-danger mt-1">{licenseFileError}</div>}
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="res_license_num">Emirates ID Copy <span className="text-danger">*</span></div>
                          <div className="upload-field-container">
                            {emiratesIdFile.length === 0 ? (
                              <button className="btn-custom-upload" onClick={openFileInputEmiratesId}>
                                <Upload className="me-2" /> Browse Files
                              </button>
                            ) : (
                              <div className="mt-2 uploaded-files-list">
                                {emiratesIdFile.map((name, i) => (
                                  <div key={i} className="uploaded-file-item">
                                    <span className="file-name">{name}</span>
                                    <Trash className="delete-icon" onClick={() => handleDeleteImageEmiratesId(i)} />
                                  </div>
                                ))}
                              </div>
                            )}
                            <input type="file" ref={fileInputRefEmiratesId} hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={handleFileChangeEmiratesId} multiple />
                            {emiratesIdFileError && <div className="text-danger mt-1">{emiratesIdFileError}</div>}
                          </div>
                        </div>
                      </div>

                      <div className="res_license_num mb-3 opacity-75">Verification Details</div>
                      <div className="row g-4">
                        <div className="col-md-6">
                          <div className="res_license_num">License Number <span className="text-danger">*</span></div>
                          <CustomInput
                            inputName="residentsLicenseNumber"
                            inputType="text"
                            className="ins_holder_sec_input_style"
                            placeholder="Eg: 995721"
                            control={control}
                            rules={rules.AuthRules.license_number}
                            onInputChange={() => { }}
                            editable={true}
                          />
                        </div>

                        <div className="col-md-6">
                          <div className="res_license_num">Emirates ID Number <span className="text-danger">*</span></div>
                          <CustomInput
                            inputName="residentsEmiratesIdNumber"
                            inputType="text"
                            className="ins_holder_sec_input_style"
                            placeholder="784-1980-1234567-8"
                            control={control}
                            rules={rules.AuthRules.emirates_id}
                            onInputChange={() => { }}
                            editable={true}
                          />
                        </div>

                        <div className="col-md-6">
                          <div className="res_license_num">License Expiry Date <span className="text-danger">*</span></div>
                          <div className="date-line-noninsurence">
                            <Calendar3 className="calendar-icon-expiry" />
                            <DatePicker
                              selected={expiryDate ? new Date(expiryDate) : null}
                              onChange={handleExpiryDateChange}
                              dateFormat="EEE, MMM d, yyyy"
                              customInput={<input readOnly className="input-date" />}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                              renderCustomHeader={renderCustomHeader}
                              calendarClassName="license-expiry-datepicker"
                              popperClassName="license-expiry-datepicker"
                              portalId="root"
                            />
                            {expiryError && <div className="text-danger mt-1">{expiryError}</div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {selectedOption1 === "Tourists" && (
                    <div className="col-12">
                      <div className="res_license_num mb-3 opacity-75">Document Uploads</div>
                      <div className="row g-4 mb-4">
                        <div className="col-12">
                          <div className="res_license_num">License Copy <span className="text-danger">*</span></div>
                          <div className="upload-field-container">
                            <button className="btn-custom-upload" onClick={openFileInputLicense2}>
                              <Upload className="me-2" /> Browse Files
                            </button>
                            <div className="mt-2 uploaded-files-list">
                              {licenseFile2.map((name, i) => (
                                <div key={i} className="uploaded-file-item">
                                  <span className="file-name">{name}</span>
                                  <Trash className="delete-icon" onClick={() => handleDeleteImageLicense2(i)} />
                                </div>
                              ))}
                            </div>
                            <input type="file" ref={fileInputRefLicense2} hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={handleFileChangeLicense2} multiple />
                            {licenseFile2Error && <div className="text-danger mt-1">{licenseFile2Error}</div>}
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="res_license_num">Passport Copy <span className="text-danger">*</span></div>
                          <div className="upload-field-container">
                            <button className="btn-custom-upload" onClick={openFileInputPassport}>
                              <Upload className="me-2" /> Browse Files
                            </button>
                            <div className="mt-2 uploaded-files-list">
                              {PassportFile.map((name, i) => (
                                <div key={i} className="uploaded-file-item">
                                  <span className="file-name">{name}</span>
                                  <Trash className="delete-icon" onClick={() => handleDeleteImagePassport(i)} />
                                </div>
                              ))}
                            </div>
                            <input type="file" ref={fileInputRefPassport} hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={handleFileChangePassport} multiple />
                            {passportFileError && <div className="text-danger mt-1">{passportFileError}</div>}
                            <div className="mt-2 text-info small fst-italic">
                              * Please provide first and last page of your passport
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="res_license_num">Visit Visa Copy <span className="text-danger">*</span></div>
                          <div className="upload-field-container">
                            <button className="btn-custom-upload" onClick={openFileInputVisitVisa}>
                              <Upload className="me-2" /> Browse Files
                            </button>
                            <div className="mt-2 uploaded-files-list">
                              {VisitVisaFile.map((name, i) => (
                                <div key={i} className="uploaded-file-item">
                                  <span className="file-name">{name}</span>
                                  <Trash className="delete-icon" onClick={() => handleDeleteImageVisitVisa(i)} />
                                </div>
                              ))}
                            </div>
                            <input type="file" ref={fileInputRefVisitVisa} hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={handleFileChangeVisitVisa} multiple />
                            {visitVisaFileError && <div className="text-danger mt-1">{visitVisaFileError}</div>}
                          </div>
                        </div>
                      </div>

                      <div className="res_license_num mb-3 opacity-75">Verification Details</div>
                      <div className="row g-4">
                        <div className="col-md-6">
                          <div className="res_license_num">License Number <span className="text-danger">*</span></div>
                          <CustomInput
                            inputName="touristsLicenseNumber"
                            inputType="text"
                            className="ins_holder_sec_input_style"
                            placeholder="Eg: 449236"
                            control={control}
                            onInputChange={() => { }}
                            editable={true}
                          />
                        </div>

                        <div className="col-md-6">
                          <div className="res_license_num">License Expiry Date <span className="text-danger">*</span></div>
                          <div className="date-line-noninsurence">
                            <Calendar3 className="calendar-icon-expiry" />
                            <DatePicker
                              selected={touristExpiryDate ? new Date(touristExpiryDate) : null}
                              onChange={handleTouristExpiryDateChange}
                              dateFormat="EEE, MMM d, yyyy"
                              customInput={<input readOnly className="input-date" />}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                              renderCustomHeader={renderCustomHeader}
                              calendarClassName="license-expiry-datepicker"
                              popperClassName="license-expiry-datepicker"
                            />
                            {touristExpiryError && <div className="text-danger mt-1">{touristExpiryError}</div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Desktop Actions */}
            <div className="non-insurance-actions">
              <button className="btn all_button_style order-back_button_outline" onClick={handleBack}>BACK</button>
              <button className="btn all_button_style continue-btn" onClick={validateAndSubmit}>CONTINUE</button>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar Summary */}
      <div className="col-lg-4 non-insurance-second-summary-section pb-4">
        <div className="sticky-sidebar">
          <RentalSummarySecondPage
            daysDifference={deliveryDetails.daysDifference}
            totalAmount={deliveryDetails.totalAmount}
            childSeatAmount={babySeatAmount}
            wtpAmount={wtpAmount}
            paiInsuranceAmount={pai_InsuranceAmount}
            cdwAmount={cdw_Amount}
            scdwAmount={scdw_Amount}
            deliveryFee={0}
            airportFee={bookingValues?.airportFee || 0}
            carImage={selectedItem?.product_details?.images?.[0]}
            onDataFromRentalSummary={handleDataFromRentalSummary}
            carModel={selectedItem?.product_details_car?.car_model}
            seat={selectedItem?.product_details_car?.number_of_seats}
            fuelType={selectedItem?.product_details_car?.fuel_type}
            isLastPage={false}
            merchantId={merchantId}
            additionalDriverFee={additionalDriverFeeAmount}
            rentalTotalVat={rentalTotalVat}
            rentalTotalStripeFeeFinal={rentalTotalStripeFeeFinal}
          />
        </div>
      </div>

      {/* Mobile Sticky Buttons */}
      <div className="non-insurance-second-button-mobile">
        <button className="btn all_button_style order-back_button_outline" onClick={handleBack}>BACK</button>
        <button className="btn all_button_style continue-btn" onClick={validateAndSubmit}>CONTINUE</button>
      </div>
    </div>
  );
};

export default NonInsuranceHolderSecondPage;
